const validURL = (host) => (typeof host === 'string' || host instanceof String) && /^https?:\/\/.*$/.test(host);

export { validURL };
